import React from 'react';
import FaroeTripTap from "./tabs/FaroeTripTap";
import FaroeProgramTab from "./tabs/FaroeProgramTab";
import FaroeAccommodationTab from "./tabs/FaroeAccommodationTab";
import FaroePriceTab from "./tabs/FaroePriceTab";
import FaroeEssentialTab from "./tabs/FaroeEssentialTab";
import TabsSection from "../common/TabsSection";


const FaroeTripDetailsSection = () => {

    return (
        <TabsSection tabs={
            [
                <FaroeTripTap/>,
                <FaroeProgramTab/>,
                <FaroeAccommodationTab/>,
                <FaroePriceTab/>,
                <FaroeEssentialTab/>
            ]}>
        </TabsSection>
    );
}

export default FaroeTripDetailsSection;
